/**
 * Returns the current edition (aka region) code from the <meta name="current-region" /> tag.
 * If the tag doesn't exist, then an empty string is returned.
 *
 * @return string
 */
export function currentRegionFromMetaTag() {
    const metaTag = document.querySelector("meta[name='current-region']");
    return metaTag?.content || "";
}
